// src/analytics.js
import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-XXXXXXXXXX"); // Replace with your GA4 Measurement ID
};

export const logPageView = (pagePath) => {
  ReactGA.send({ hitType: "pageview", page: pagePath });
};

export const logEvent = ({ category, action, label }) => {
  ReactGA.event({ category, action, label });
};
